import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ConfigProvider {
  private cfg: object = null;

  constructor(private http: HttpClient) {}

  public getConfig(): object {
    return this.cfg;
  }

  loadConfig() {
    return new Promise((resolve, reject) => {
      this.http.get('config.json').subscribe(
        (response) => {
          console.log('configuration - CHECK!');
          this.cfg = response;
          resolve(true);
        },
        (err) => {
          console.error('configuration - FAIL!');
        }
      );
    });
  }
}

export const CONFIG_PROVIDER: Array<any> = [{ provide: ConfigProvider, useClass: ConfigProvider }];
